<!-- Note that we're using error here -->
<!-- Because that's the only prop that reliably generates ADA announcement -->
<template>
  <div>
    <vue3-snackbar
      bottom
      shadow
      duration="10000"
      :error="error ? '#BF2D00' : '#587B84'"
      aria-hidden="true"
      @added="snackAdded"
      @cleared="snackCleared"
      @removed="snackCleared"
      @dismissed="snackCleared"
    >
      <template #message-action="{ message }">
        <v-btn
          v-if="message.action == 'restriction-terms'"
          class="flashbar-more-btn"
          aria-hidden="true"
          @click="showRestrictionDialog = true"
        >
          More
        </v-btn>
      </template>
      <template #message-icon="{ message }">
        <v-icon class="icon" aria-hidden="true">
          fa-solid {{ icon_string(message) }}
        </v-icon>
      </template>
    </vue3-snackbar>
    <RestrictionTerms
      v-model="showRestrictionDialog"
      :therapist="isTherapist"
      :supplemental="isSupplemental"
      :student="isStudent"
    />
  </div>
</template>

<script>
import RestrictionTerms from "./RestrictionTerms.vue";

export default {
  name: "FlashMessage",
  components: {
    RestrictionTerms
  },
  data: () => ({
    message_type: "",
    currentMessage: "",
    isDisplayingMessage: false,
    fullMessage: null,
    isExpanded: false,
    showRestrictionDialog: false,
    isTherapist: false,
    isSupplemental: false,
    isStudent: false,
    isExistingAppointment: false,
    error: false
    //queuedMessages: []
  }),
  watch: {
    // Per Pedrelli, we're deprecating the message queue.
    // Leaving this in case we want to implement priority messaging;
    //isDisplayingMessage(val){
      // console.log(`isdisplaying ${val}`)
    //   if(val == true || this.queuedMessages.length == 0) return;

    //   this.displayMessage(this.queuedMessages[0]);
    //   this.queuedMessages.splice(0,1);
    // }
    // continues...
  },
  mounted: function() {

    window.Bus.$on("flash-message", message => {
      // continuing queue deprecation from above
      // console.log('message event recieved');

      // if (this.isDisplayingMessage && message.message_type != "error"){
      //   this.queuedMessages.push(message);
      // }else{
      this.displayMessage(message);
      // }
    });
  },
  methods: {
    snackAdded: function() {
      this.isDisplayingMessage = true;
    },
    snackCleared: function() {
      this.isDisplayingMessage = false;
    },
    displayMessage: function(message) {
      this.fullMessage = message;
      this.currentMessage = Array.isArray(message.text)
        ? message.text[0]
        : message.text;
      this.message_type = message.message_type ? message.message_type : "error";
      this.error = message.error;
      this.isExpanded = false;
      this.isSupplemental = message.supplemental;
      this.isTherapist = message.therapist;
      this.isStudent = message.student;
      this.isExistingAppointment = message.existing_appointment;
      this.$snackbar.add({
        type: this.message_type,
        text: this.currentMessage,
        action: message.action
      });
    },
    icon_string: function(message) {
      // TODO: We need an ADA pass to ensure other message types now do
      // screen reader events. Delete uncommented code, and uncomment the below
      let icons = {
        success: "fa-circle-check",
        error: "fa-hexagon-exclamation",
        info: "fa-circle-exclamation",
        warning: "fa-triangle-exclamation"
      };
      // console.log(message);

      return icons[message.type];
      // return "fa-circle-exclamation";
    },
    showRestrictionTerms() {
      this.showRestrictionDialog = true;
    },
    closeRestrictionDialog() {
      this.showRestrictionDialog = false;
    }
  }
};
</script>
<style>
.vue3-snackbar-message-close {
  margin-left: 8px !important;
}
.vue3-snackbar-message-icon {
  margin-right: 8px;
}
.vue3-snackbar-message-icon .v-icon {
  width: 18px;
  height: 25px;
}
.vue3-snackbar-message {
  width: fit-content !important;
}
.vue3-snackbar-message-wrapper {
  display: flex !important;
  max-height: auto;
  overflow: hidden;
  padding: 12px;
  box-sizing: border-box;
  width: auto;
  max-width: 100%;
  min-width: 150px;
}
.vue3-snackbar-message-content {
  flex-flow: row !important;
  width: auto !important;
}
#vue3-snackbar--container {
  display: inline-block;
  max-width: 100%;
}
.vue3-snackbar-message-action {
  margin: auto 8px;
  width: fit-content !important;
  padding-top: 0 !important;
}
.flashbar-more-btn {
  background: transparent;
  border: 1px solid white;
  text-transform: none;
  padding: 6px 12px;
}

.flashbar-more-btn .v-btn__content {
  font-weight: 500;
  font-family: "Roboto";
}
.vue3-snackbar-message-title {
  display: flex;
  align-items: center;
  margin: 0;
}
</style>
